module.exports = __webpack_public_path__ + "static/media/22-en.fd5c88f4.svg";